module.exports = new __parcel__URL__("tm54dvar-ch4flux-monthgrid-v1.thumbnails.pyrogenic.bf0d20b0.png").toString();